import { jsx } from 'react/jsx-runtime';
import '../components/CellRenderers/CheckboxCellRenderer.js';
import '../components/CellRenderers/TextCellRenderer.js';
import '../components/CellRenderers/StatusCellRenderer.js';
import RowMenuRenderer from '../components/CellRenderers/RowMenuRenderer.js';
import '../components/CellRenderers/TextWithActionsOnHoverRenderer.js';

const useRowMenu = (hooks) => {
    const { getRowMenu, onRowMenuOpen, onRowMenuClose, denseRowMenu = true, rtl } = hooks.dataTableOptions;
    if (getRowMenu) {
        hooks.visibleColumns.push((columns, { instance }) => [
            ...columns,
            {
                id: 'row-menu-column',
                accessor: 'id',
                Header: '',
                rowMenu: true,
                Cell: props => (jsx(RowMenuRenderer, Object.assign({ getRowMenu: instance.dataTableOptions.getRowMenu, onRowMenuOpen: onRowMenuOpen, onRowMenuClose: onRowMenuClose, denseRowMenu: denseRowMenu }, props, { rtl: rtl }))),
                minWidth: 48,
                maxWidth: 48,
                disableResizing: true,
                disableSortBy: true,
            },
        ]);
        hooks.getCellProps.push((props) => {
            const rowMenuProps = {
                rowMenu: true,
                style: {
                    zIndex: 3,
                },
            };
            return props.key.indexOf('row-menu-column') !== -1 ? [props, rowMenuProps] : [props];
        });
    }
};

export { useRowMenu as default };
//# sourceMappingURL=useRowMenu.js.map
